//#region libraries
import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { resetSkip } from '../../../redux/slices/assistance-bookings/booking-requests-table';

// bootstrap
import Form from 'react-bootstrap/Form';
//#endregion

const SearchBar = (props) => {

    const dispatch = useDispatch();
    const [search, setSearch] = useState('')

    const userDb = useSelector(selectUserDb)

    function translateType(type, confirmedType, userDb) {
        if (userDb?.details?.type == 'AIRLINE' && type == 'requests') {
            return {
                "requests": "airlineRequests",
                "confirmed": "airlineConfirmedRequests"
            }[type]
        }
        if (type != "confirmed") {
            return {
                "departures": "pendingDepartures",
                "arrivals": "pendingArrivals"
            }[type]
        }
        else {
            return {
                "departures": "confirmedDepartures",
                "arrivals": "confirmedArrivals"
            }[confirmedType]
        }
    }

    const handleChange = (e) => {
        dispatch(resetSkip(translateType(props.type, props.confirmedType, userDb)))
        props.setSearchConfirmed(e.target.value)
        setSearch(e.target.value)
    }


    return (
        <div>

            <Form.Control
                type="text"
                placeholder="Search using passenger name"
                value={search}
                onChange={handleChange}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        dispatch(resetSkip(translateType(props.type, props.confirmedType, userDb)))
                        props.setSearchConfirmed(e.target.value)
                    }
                }}
            />
        </div>
    )
}

export default SearchBar;